import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { partnersApi } from "./api";
import type { Partner, PartnerInput } from "./types";

export const partnerKeys = {
  all: ["partners"] as const,
  publicList: ["partners", "public-list"] as const,
};

export function usePublicPartners() {
  return useQuery({ queryKey: partnerKeys.publicList, queryFn: partnersApi.publicList });
}

export function usePartners() {
  return useQuery({ queryKey: partnerKeys.all, queryFn: partnersApi.list });
}

export function useCreatePartner() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ input, logoFile }: { input: PartnerInput; logoFile?: File | null }) => partnersApi.create(input, logoFile),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: partnerKeys.all }),
  });
}

export function useUpdatePartner() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ partner, input, logoFile }: { partner: Partner; input: PartnerInput; logoFile?: File | null }) =>
      partnersApi.update(partner.id, input, logoFile),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: partnerKeys.all }),
  });
}

export function useDeletePartner() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: partnersApi.delete,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: partnerKeys.all }),
  });
}
